import { useNavigate } from '@tanstack/react-router';
import React from 'react';
import useLocationHash from 'utils/hooks/useLocationHash';
import usePreviousValue from 'utils/hooks/usePreviousValue';
import {
  computeSlideInMenuState,
  createSlideInMenuAnchorLink,
} from './SlideInMenu.helpers';
import { SlideInMenuState } from './SlideInMenu.type';

export function useComputeSlideInMenuState(): SlideInMenuState {
  const urlFragmentWithHash = useLocationHash();

  const [{ isOpen, currentTab }, setSlideInMenuState] = React.useState(() =>
    computeSlideInMenuState(urlFragmentWithHash),
  );

  // We intentionally delay to improve perf reducing unresponsivness
  // adding a bit of pause between the synchronous
  // click response and the rendering of the menu.
  React.useEffect(() => {
    setTimeout(() => {
      setSlideInMenuState(computeSlideInMenuState(urlFragmentWithHash));
    }, 20);
  }, [urlFragmentWithHash]);

  const previousCurrentTab = usePreviousValue(currentTab, Boolean);

  return {
    isOpen,
    activeTabIndex: (currentTab || previousCurrentTab) - 1,
  };
}

export const useSlideInMenuControlls = () => {
  const navigate = useNavigate();

  const openSlideInMenu = (atOneBasedIndex = 1) => {
    navigate({
      to: '.',
      hash: createSlideInMenuAnchorLink(atOneBasedIndex),
      replace: true,
    });
  };
  const closeSlideInMenu = () => {
    navigate({ to: '.', hash: '', replace: true });
  };

  return { openSlideInMenu, closeSlideInMenu };
};
